
var _categoryTopHints = [];
var _categoryBottomHints = [];
var _sectionTopHint = null;
var _sectionBottomHint = null;
var _columnHeaderHints = [];
var _criteriaHints = [];
var _ingredientHints = [];

var _addHintUrl = null;
var _formId = null;
var _sectionId = null;
var _categoryId = null;
var _controllerName = "";
var _localizedHintTextTitle = "";
var _localizedHintPlaceHolder = "";
var _localizedSaveText = "";
var _localizedCancelText = "";
var _localizedShowAsIcon = "";
var _localizedDeleteHint = "";

function HintsModule(options) {
    _categoryTopHints = [];
    _categoryBottomHints = [];
    _sectionTopHint = null;
    _sectionBottomHint = null;
    _columnHeaderHints = [];
    _criteriaHints = [];
    _ingredientHints = [];
    
    var isEditMasterForm = false;

    _addHintUrl = options.urls.addHint;

    _formId = options.variables.formId;
    _sectionId = options.variables.sectionId;
    _categoryId = options.variables.categoryId;
    _localizedHintTextTitle = options.variables.localizedHintTextTitle;
    _localizedHintPlaceHolder = options.variables.localizedHintPlaceHolder;

    _localizedSaveText = options.variables.localizedSaveText;
    _localizedCancelText = options.variables.localizedCancelText;

    _localizedShowAsIcon = options.variables.localizedShowAsIcon;
    _localizedDeleteHint = options.variables.localizedDeleteHint;

    isEditMasterForm = options.isEdit.edit;

    $.get(options.urls.hints, receiveHints);

    function receiveHints(data) {
        for (var i = 0; i < data.length; i++) {
            var hint = data[i];

            // all hints are loaded per form and section in single call
            // but since some are for e.g.category or criterias that are not loaded and displayed yet, the hints must be just stored here
            // and displayed at appopriate moment by calling the function viewSpecificationHints()

            switch (hint.HintElementType) {
                case "SectionTopHint":
                    {
                        _sectionTopHint = hint;
                    }
                    break;
                case "SectionBottomHint":
                    {
                        _sectionBottomHint = hint;
                    }
                    break;
                case "CategoryTopHint":
                    {
                        _categoryTopHints.push(hint);
                    }
                    break;
                case "CategoryBottomHint":
                    {
                        _categoryBottomHints.push(hint);
                    }
                    break;
                case "ColumnHeader":
                    {
                        _columnHeaderHints.push(hint);
                    }
                    break;
                case "Ingredient":
                    {
                        _ingredientHints.push(hint);
                    }
                    break;
                case "Criteria":
                    {
                        _criteriaHints.push(hint);
                    }
                    break;
                default:
                    break;
            }
        }
        viewSpecificationHints(isEditMasterForm);
    }
}

function addHint(hint, element, clientId, isEdit) {

    var hintEditTypeClass = isEdit ? "sp-editable-hint" : "sp-readonly-hint";

    if (hint.HintTypeId == 1) {
        element.css("cursor", "pointer");
        element.kendoTooltip({
            content: hint.Text,
            width: 250,
            show: onShowHint,
            position: "right"
        });
    } else if (hint.HintTypeId == 2 && element.siblings(".editable-component-container").length == 0) {
        if (element.prev("#" + hint.HintElementType + "-" + hint.HintId).length == 0) {

            var html = "<div class='editable-component-container'>";
            html += "<div ";
            if (isEdit) {
                html += " onclick = 'openForEditIconHintIngredientsDefinitionColumn(event)'  style='text-transform: none;' title='" + _localizedHintTextTitle + "' ";
            }
            html += " class='editable-component-readonly " + hintEditTypeClass + "' id='" + hint.HintElementType + "-" + hint.HintId + "'  >" + hint.Text + " </div>";
            html += "<div class='editable-component-edited' style='display: none'>";
            html += "<textarea class='form-control editable-component-edited-control advanced-textarea'   placeholder='" + _localizedHintPlaceHolder + "'   ></textarea>";
            html += "<div class='btn-group' role='group'>";
            html += "<button class=\'btn btn-primary enter'>"+_localizedSaveText+"</button>";
            html += "<button class='btn btn-default cancel'>" + _localizedCancelText +"</button>";
            html += "</div></div></div>";
            element.before(html);

        }
    } else if (hint.HintTypeId == 3) {
        if (element.next("#" + hint.HintElementType + "-" + hint.HintId).length == 0 && element.siblings(".editable-component-container").length == 0) {
            var style = "";
            var elemFunction = "";
            var criteriastyle = "";

            if (hint.HintElementType == "ColumnHeader") {
                style = "font-size: 12px; margin-left: 10px;";
                criteriastyle += "font-size: 12px; margin-left:" + element.css("margin-left") +" ";
            }

            if (hint.HintElementType == "Criteria") {

                if (element.parent().css("display") == "none") {
                    element.parent().css("display", "block");
                }

                elemFunction = " onclick = 'openForEditIconHintDefinition(event)' title='" + _localizedHintTextTitle + "' ";
                style = "font-size: 12px;";
            } else {
                elemFunction = " onclick = 'openForEditIconHintIngredientsDefinitionColumn(event)' style='text-transform: none; " + style + " ' title='" + _localizedHintTextTitle + "' ";
            }

            if (!isEdit && hint.HintElementType == "Criteria") {
                criteriastyle = " margin-left: 10px; font-size: 11px; ";
            } 

            if (isEdit && hint.HintElementType == "Criteria") {
                criteriastyle = "  font-size: 11px; ";
            } 

            var html = "<div class='editable-component-container'> ";

            html += "<div data-hint-id='CriteriaID_" + hint.ParamValue + "_" + hint.ColumnName + "' style='text-transform: none; " + criteriastyle + "'";
            if (isEdit) {
                html += elemFunction;
            } 

            if ($(element).prev().hasClass('sp-field-right-align') == true) {
                hintEditTypeClass += " sp-field-right-align";
            }

            html += " class='editable-component-readonly " + hintEditTypeClass + "'  id = '" + hint.HintElementType + "-" + hint.HintId + "' > " + hint.Text + " </div > ";
            html += "<div class='editable-component-edited' style='display: none'>";
            html += "<textarea class='form-control editable-component-edited-control advanced-textarea'  placeholder='" + _localizedHintPlaceHolder + "' ></textarea>";
            html += "<div class='btn-group' role='group'>";
            html += "<button class=\'btn btn-primary enter'>" + _localizedSaveText +"</button>";
            html += "<button class='btn btn-default cancel'>" + _localizedCancelText +"</button>";
            html += "</div></div></div>";
            element.after(html);
        }
    } else if (hint.HintTypeId == 4) {
        if (element.next("#" + hint.HintElementType + "-" + hint.HintId).length == 0 && element.siblings(".editable-component-container").length == 0) {

            var html = "<div class='editable-component-container'>";

            html += "<div ";
            if (isEdit) {
                html += " onclick='openForEditIconHintIngredientsDefinitionColumn(event)'  style='text-transform: none;' title='" + _localizedHintTextTitle + "' ";
            }
            html += " class='editable-component-readonly " + hintEditTypeClass + "' id = '" + hint.HintElementType + "-" + hint.HintId + "' > " + hint.Text + " </div > ";
            html += "<div class='editable-component-edited' style='display: none'>";
            html += "<textarea class='form-control editable-component-edited-control advanced-textarea'  placeholder='" + _localizedHintPlaceHolder + "' ></textarea>";
            html += "<div class='btn-group' role='group'>";
            html += "<button class=\'btn btn-primary enter'>" + _localizedSaveText +"</button>";
            html += "<button class='btn btn-default cancel'>" + _localizedCancelText +"</button>";
            html += "</div></div></div>";
            element.after(html);
        }
    } else if (hint.HintTypeId == 5) {
        if (element.find(".vertical-align-center block").length == 0) {
            var hintIcon;
            if (hint.IconPath != null) {
                hintIcon = document.createElement("img");
                hintIcon.src = hint.IconPath;
                hintIcon.width = 16;
                hintIcon.height = 16;
            } else {
                hintIcon = document.createElement("span");
            }

            element.append(hintIcon);

            if (hint.HintElementType == "ColumnHeader") {
                element.attr('onClick', 'openForEditIconHintIngredientsDefinition(event);');
                element.attr('data-hint-id', "ColumnHeader-" + hint.HintId);
                element.attr('title', _localizedHintTextTitle);
            }

            var icon = $(hintIcon);
            icon.css("cursor", "pointer");
            icon.addClass("specification-hint");

            if (hint.HintElementType == "Criteria" && !isEdit) {
                icon.css("margin-left", "20px");
            }

            if (hint.IconPath == null) {
                icon.addClass("fa fa-info-circle");
            }
            icon.kendoTooltip({
                content: hint.Text,
                width: 250,
                show: onShowHint,
                position: "right"
            });

            var parent = $(element[0].parentNode);
            var column = parent.closest('.criteria-column');
            var width = parent.width() + 19;
            if (width < column.width()) {
                parent.css('max-width', '100%');
            }
        }
    }
}

function onShowHint(e) {
    this.popup.element.addClass("tooltip_border");
}

// view hints for sections and categories
function viewSpecificationHints(isEditMasterForm) {
    // remove all current hints
    $(".specification-hint").remove();
    $("#BottomSpecHintsRow").hide();
    $("#TopSpecHintsRow").hide();
    $("#CategoryTopHint").hide();
    $("#CategoryBottomHint").hide();
    $("#SectionTopHint").hide();
    $("#SectionBottomHint").hide();

    var isEdit = false;
    if (isEditMasterForm != undefined) {
        isEdit = isEditMasterForm;
    }

    var hintEditTypeClass = isEdit ? "sp-editable-hint" : "sp-readonly-hint";

    //HINTS EDIT DISABLED HERE!!!
    //isEdit = false;

    if (_sectionTopHint) {
        if (_sectionTopHint.HintTypeId == 5) {
            var hintIcon = document.createElement("span");
            $("#SectionTopHintText").append(hintIcon);
            $("#SectionTopHintText").show();
            //$("#TopSpecHintsRow").show();
            $("#SectionTopHintText").attr('onClick', 'openForEditHintIconSection(event);');
            $("#SectionTopHintText").attr('data-hint-id', "sectionTopHint-" + _sectionTopHint.HintId);
            $("#SectionTopHintText").attr('title', _localizedHintTextTitle);
            var icon = $(hintIcon);
            icon.css("cursor", "pointer");
            icon.addClass("specification-hint");
            if (_sectionTopHint.IconPath == null) { icon.addClass("fa fa-info-circle"); }
            icon.kendoTooltip({
                content: _sectionTopHint.Text,
                width: 250,
                show: onShowHint,
                position: "right"
            });
        } else {
            var html = "<div class='editable-component-container' >";
            html += "<div ";
            if (isEdit) { html += " onclick='openForEditHintDefinition(event)' title='" + _localizedHintTextTitle + "' "; }
            html += " class='editable-component-readonly " + hintEditTypeClass + "' id = 'sectionTopHint-" + _sectionTopHint.HintId + "' > " + _sectionTopHint.Text + " </div > ";
            html += "<div class='editable-component-edited' style='display: none'>";
            html += "<textarea class='form-control editable-component-edited-control advanced-textarea'  placeholder='" + _localizedHintPlaceHolder + "' ></textarea>";
            html += "<div class='btn-group' role='group'>";
            html += "<button class=\'btn btn-primary enter'>" + _localizedSaveText +"</button>";
            html += "<button class='btn btn-default cancel'>" + _localizedCancelText +"</button>";
            html += "</div></div></div>";
            $("#SectionTopHint").html(html);
            $("#SectionTopHint").show();
            $("#TopSpecHintsRow").show();
        }
    }

    if (_sectionBottomHint) {
        if (_sectionBottomHint.HintTypeId == 5) {
            var hintIcon = document.createElement("span");
            $("#SectionBottomHint").append(hintIcon);
            $("#SectionBottomHint").show();
            $("#BottomSpecHintsRow").show();
            $("#SectionBottomHint").attr('onClick', 'openForEditHintIconSection(event);');
            $("#SectionBottomHint").attr('data-hint-id', "sectionBottomHint-" + _sectionBottomHint.HintId);
            $("#SectionBottomHint").attr('title', _localizedHintTextTitle);
            var icon = $(hintIcon);
            icon.css("cursor", "pointer");
            icon.addClass("specification-hint");
            if (_sectionBottomHint.IconPath == null) { icon.addClass("fa fa-info-circle"); }
            icon.kendoTooltip({
                content: _sectionBottomHint.Text,
                width: 250,
                show: onShowHint,
                position: "right"
            });
        } else {
            var html = "<div class='editable-component-container'>";
            html += "<div ";
            if (isEdit) { html += " onclick='openForEditHintDefinition(event)' title='" + _localizedHintTextTitle + "' "; }
            html += " class='editable-component-readonly " + hintEditTypeClass + "' id = 'sectionBottomHint-" + _sectionBottomHint.HintId + "' > " + _sectionBottomHint.Text + " </div > ";
            html += "<div class='editable-component-edited' style='display: none'>";
            html += "<textarea class='form-control editable-component-edited-control advanced-textarea'  placeholder='" + _localizedHintPlaceHolder + "' ></textarea>";
            html += "<div class='btn-group' role='group'>";
            html += "<button class=\'btn btn-primary enter'>" + _localizedSaveText +"</button>";
            html += "<button class='btn btn-default cancel'>" + _localizedCancelText +"</button>";
            html += "</div></div></div>";
            $("#SectionBottomHint").html(html);
            $("#SectionBottomHint").show();
            $("#BottomSpecHintsRow").show();
        }
    }

    // view category hints
    var categoryId = getCategoryId();
    if (categoryId) {
        var topHintIndex = findIndexIESafe(_categoryTopHints.map(function (e) { return e.ParamValue }),
            categoryId.toString());
        if (topHintIndex >= 0) {
            var topHint = _categoryTopHints[topHintIndex];
            if (topHint.HintTypeId == 5) {
                var hintIcon = document.createElement("span");
                $("#CategoryTopHintText").append(hintIcon);
                $("#CategoryTopHintText").show();
                //$("#TopSpecHintsRow").show();
                if (isEdit) {
                    $("#CategoryTopHintText").attr('onClick', 'openForEditHintIconSection(event);');
                }
                $("#CategoryTopHintText").attr('data-hint-id', "CategoryTopHint-" + topHint.HintId);
                $("#CategoryTopHintText").attr('title', _localizedHintTextTitle);

                var icon = $(hintIcon);
                icon.css("cursor", "pointer");
                icon.addClass("specification-hint");
                if (topHint.IconPath == null) { icon.addClass("fa fa-info-circle"); }
                icon.kendoTooltip({
                    content: topHint.Text,
                    width: 250,
                    show: onShowHint,
                    position: "right"
                });
            } else {
                var html = "<div class='editable-component-container'>";
                html += "<div ";
                if (isEdit) { html += " onclick='openForEditHintDefinition(event)' title='" + _localizedHintTextTitle + "' "; }
                html += " class='editable-component-readonly " + hintEditTypeClass + "' id = 'CategoryTopHint-" + topHint.HintId + "-" + topHint.ParamValue + "' > " + topHint.Text + " </div > ";
                html += "<div class='editable-component-edited' style='display: none'>";
                html += "<textarea class='form-control editable-component-edited-control advanced-textarea'  placeholder='" + _localizedHintPlaceHolder + "' ></textarea>";
                html += "<div class='btn-group' role='group'>";
                html += "<button class=\'btn btn-primary enter'>" + _localizedSaveText +"</button>";
                html += "<button class='btn btn-default cancel'>" + _localizedCancelText +"</button>";
                html += "</div></div></div>";
                $("#CategoryTopHint").html(html);
                $("#CategoryTopHint").show();
                $("#TopSpecHintsRow").show();
            }
        }

        var bottomHintIndex = findIndexIESafe(_categoryBottomHints.map(function (e) { return e.ParamValue }),
            categoryId.toString());
        if (bottomHintIndex >= 0) {
            var bottomHint = _categoryBottomHints[bottomHintIndex];

            if (bottomHint.HintTypeId == 5) {
                var hintIcon = document.createElement("span");
                $("#CategoryBottomHint").append(hintIcon);
                $("#CategoryBottomHint").show();
                $("#BottomSpecHintsRow").show();
                $("#CategoryBottomHint").attr('onClick', 'openForEditHintIconSection(event);');
                $("#CategoryBottomHint").attr('data-hint-id', "CategoryBottomHint-" + bottomHint.HintId);
                $("#CategoryBottomHint").attr('title', _localizedHintTextTitle);
                var icon = $(hintIcon);
                icon.css("cursor", "pointer");
                icon.addClass("specification-hint");
                if (bottomHint.IconPath == null) { icon.addClass("fa fa-info-circle"); }
                icon.kendoTooltip({
                    content: bottomHint.Text,
                    width: 250,
                    show: onShowHint,
                    position: "right"
                });
            } else {

                var html = "<div class='editable-component-container'>";
                html += "<div ";
                if (isEdit) { html += " onclick='openForEditHintDefinition(event)' title='" + _localizedHintTextTitle + "' "; }
                html += " class='editable-component-readonly " + hintEditTypeClass + "' id = 'CategoryBottomHint-" + bottomHint.HintId + "-" + bottomHint.ParamValue + "' > " + bottomHint.Text + " </div > ";
                html += "<div class='editable-component-edited' style='display: none'>";
                html += "<textarea class='form-control editable-component-edited-control advanced-textarea'  placeholder='" + _localizedHintPlaceHolder + "' ></textarea>";
                html += "<div class='btn-group' role='group'>";
                html += "<button class=\'btn btn-primary enter'>" + _localizedSaveText +"</button>";
                html += "<button class='btn btn-default cancel'>" + _localizedCancelText +"</button>";
                html += "</div></div></div>";
                $("#CategoryBottomHint").html(html);
                $("#CategoryBottomHint").show();
                $("#BottomSpecHintsRow").show();
            }
        }
    }

    for (var i in _columnHeaderHints) {
        var headerHint = _columnHeaderHints[i];

        if (headerHint == undefined) {
            continue;
        }

        var selector = "";

        if (headerHint.ParamName == "CategoryID") {
            selector = "[data-category-id='" + headerHint.ParamValue + "']";
        }

        var clientId = "th[data-field='" + headerHint.ColumnName + "']" + selector + "> .ingredient-header";
        var element = $(clientId);

        if (element.length > 0) {
            addHint(headerHint, element, clientId, isEdit);
        }

        clientId = "th[data-field-name='" + headerHint.ColumnName + "']" + selector + "> .criteria-column .specification-hint-holder";
        element = $(clientId);
        if (element.length > 0) {
            addHint(headerHint, element, clientId, isEdit);
        }

        clientId = "th[data-field-name='" + headerHint.ColumnName + "']" + selector;
        element = $(clientId).find(".criteria-column-content");
        if (element.length > 0) {
            addHint(headerHint, element, clientId, isEdit);
        }
    }

    for (var i in _criteriaHints) {
        var criteriaHint = _criteriaHints[i];

        if (criteriaHint == undefined) {
            continue;
        }

        var clientId = "";
        if (criteriaHint.HintTypeId == 5) {
            clientId = "[data-hint-id='" + criteriaHint.ParamName + "_" + criteriaHint.ParamValue + "_" + criteriaHint.ColumnName + "_I']";
        } else {
            clientId = "[data-hint-id='" + criteriaHint.ParamName + "_" + criteriaHint.ParamValue + "_" + criteriaHint.ColumnName + "_T']";
        }

        element = $(clientId);
        if (element.length > 0) {
            addHint(criteriaHint, element, clientId, isEdit);
        }
    }

    for (var i in _ingredientHints) {
        var ingredientHint = _ingredientHints[i];

        if (ingredientHint == undefined) {
            continue;
        }

        var clientId = ".name-wrap > [data-id=" + ingredientHint.ParamValue + "]";
        element = $(clientId);

        if (element.length > 0) {
            addHint(ingredientHint, element, clientId, isEdit);
        }
    }
}

function deleteHint(hintId) {
    var splittedSecID = hintId.split('-');
    var hintId = parseInt(splittedSecID[1]);
    $('#hintId').val(hintId);
    activateModal("#deleteHintConfirmModal");
}

function deleteHintForSpecData(hintId) {
    deactivateModal("#editIconHintModal");
    deactivateModal("#editIconHintModalIngredients");
    var splittedSecID = hintId.split('-');
    var hintId = parseInt(splittedSecID[1]);
    $('#hintIdForSpecData').val(hintId);
    activateModal("#deleteHintConfirmModalForSpecData");
}

function deleteHintForSpecDataIngredients(hintId) {

    deactivateModal("#editIconHintModalIngredients");
    var splittedSecID = hintId.split('-');
    var hintId = parseInt(splittedSecID[1]);
    $('#hintId').val(hintId);
    activateModal("#deleteHintConfirmModal");
}

function openForEditIconHintDefinition(e) {
    e.stopPropagation();
    e.preventDefault();

    var firstParent = $(e.srcElement || e.target).parent().parent().find('.inline-block');
    var sender = $(e.srcElement || e.target).closest('.inline-block');
    if (firstParent.length > 0) { sender = firstParent; }
    var dataattr = sender.data("hint-id");
    var splittedSecID = dataattr.split('_');
    var pName = splittedSecID[0];
    var pValue = parseInt(splittedSecID[1]);
    var colName = splittedSecID[2];
    var hintText = "";
    var hintId = 0;
    var HintTypeIdValue = 0;
    var isHintFound = false;


    for (var i in _criteriaHints) {
        var criteriaHint = _criteriaHints[i];
        if (criteriaHint.HintElementType == "Criteria" && criteriaHint.ParamValue == pValue) {
            hintText = criteriaHint.Text;
            hintId = criteriaHint.HintId;
            HintTypeIdValue = criteriaHint.HintTypeId;
            isHintFound = true;
            break;
        }

        if (criteriaHint.HintElementType == "CriteriaHint" && criteriaHint.ParamValue == pValue) {
            isHintFound = true;
            break;
        }

    }

    if (!isHintFound) {
        return;
    }

    $('#hintEditIconId').val(hintId);
    activateModal("#editIconHintModal");
    var tArea = $("#editIconHintModal").find(".advanced-textarea");

    var editableCompEdited = $("#editIconHintModal").find(".editable-component-edited");
    editableCompEdited.show();
    var trumbowygBox = editableCompEdited.find(".trumbowyg-box");
    var trumbowygButtonPane = trumbowygBox.find(".trumbowyg-button-pane");
    trumbowygBox.find(".trumbowyg-editor").attr('placeholder', _localizedHintPlaceHolder);

    tArea.trumbowyg('html');
    setTimeout(function () { tArea.trumbowyg('html', hintText); }, 100);
    tArea.trumbowyg({
        svgPath: '/Content/trumbowyg/icons.svg',
        urlProtocol: 'http',
        defaultLinkTarget: '_blank',
        btns: [['formatting'], ['bold', 'italic', 'underline'], ['removeformat'], ['link'], ['foreColor']]
        ,
        plugins: {
            fontfamily: {
                fontList: [
                    { name: 'Arial', family: 'Arial, Helvetica, sans-serif' },
                    { name: 'Open Sans', family: '\'Open Sans\', sans-serif' }
                ]
            }
        }
    });

    $("#submitBtn").one("click",
        function () {
            var sender = tArea;
            var text = removeEmptyHtmlTags($(sender).trumbowyg('html'));
            var specificationHintsShowAsIconToggleButton = $("#specificationHintsShowAsIconToggleButton" + hintId);
            var showAsIcon = specificationHintsShowAsIconToggleButton.find("input").prop("checked");
            $('#textId').val(JSON.stringify(text));
            $('#hintEditIconId').val(hintId);
            $('#paramName').val(pName);
            $('#paramValue').val(pValue);
            $('#colName').val(colName);
            $('#asIcon').val(showAsIcon);
        });

    $("#cancelBtnIngredients").one("click",
        function () {
            RemoveAllNewHints();
        });

    $("#XBtnIngredients").one("click",
        function () {
            RemoveAllNewHints();
        });

    var isChecked = "";
    if (HintTypeIdValue == 5 || hintId == 0) {
        isChecked = "checked";
    }

    trumbowygButtonPane.find('.vertical-align-center').remove();

    var html = "<div id='specificationHintsShowAsIconToggleButton" + hintId + "' class='vertical-align-center block' style='display: normal; margin-left: 20px;'>";
    html += "<div class='toggle-switch' > <label class='switch' ><input type='checkbox' " + isChecked + " autocomplete='off'></input><span class='slider round' style='display: block'></span></label></div >";
    html += "<label class='control-label'>" + _localizedShowAsIcon + "</label>";
    html += "</div>";
    trumbowygButtonPane.append(html);

    html = "<div id='specificationHintsDeleteButton" + hintId + "'  onclick='deleteHintForSpecData(\"CriteriaHint-" + hintId + "\")' class='vertical-align-center block' style='display: normal; margin-left: 20px;'>";
    html += "<div class='button'><label class='button' ><button type='button'  autocomplete='off' class='fa fa-trash' ></button></label></div>";
    html += "<label class='control-label'>" + _localizedDeleteHint + "</label>";
    html += "</div>";
    trumbowygButtonPane.append(html);
}

function openForEditHintIconSection(e) {
    e.stopPropagation();
    e.preventDefault();

    var firstParent = $(e.srcElement || e.target);
    var firstSecTypeId = $(firstParent).data('hint-id');
    var hintSectionTypeId = firstSecTypeId;

    if (firstSecTypeId == undefined) {
        var sender = $(e.srcElement || e.target).parent();
        hintSectionTypeId = $(sender).data('hint-id');
    }

    var splittedSecID = hintSectionTypeId.split('-');
    var pName = splittedSecID[0];
    var pValue = parseInt(splittedSecID[1]);
    var hintText = ""; 
    var hintId = 0;

    var HintTypeIdValue = 0;
    var HintFormId = 0;
    var HintSectonId = 0;
    var isHintFound = false;

    if (pName == "sectionTopHint") {
        hintText = _sectionTopHint.Text;
        hintId = _sectionTopHint.HintId;
        HintTypeIdValue = _sectionTopHint.HintTypeId;
        HintFormId = _sectionTopHint.FormId;
        HintSectonId = _sectionTopHint.SectionId;
        isHintFound = true;
    }

    if (!isHintFound) {
        if (pName == "sectionBottomHint") {
            hintText = _sectionBottomHint.Text;
            hintId = _sectionBottomHint.HintId;
            HintTypeIdValue = _sectionBottomHint.HintTypeId;
            HintFormId = _sectionBottomHint.FormId;
            HintSectonId = _sectionBottomHint.SectionId;
            isHintFound = true;
        }
    }

    if (!isHintFound) {
        if (pName == "CategoryTopHint") {
            for (var i in _categoryTopHints) {
                var criteriaHint = _categoryTopHints[i];
                if (criteriaHint.HintId == pValue) {
                    hintText = criteriaHint.Text;
                    hintId = criteriaHint.HintId;
                    HintTypeIdValue = criteriaHint.HintTypeId;
                    HintFormId = criteriaHint.FormId;
                    HintSectonId = criteriaHint.SectionId;
                    isHintFound = true;
                    break;
                }
            }
        }
    }

    if (!isHintFound) {
        if (pName == "CategoryBottomHint") {
            for (var i in _categoryBottomHints) {
                var criteriaHint = _categoryBottomHints[i];
                if (criteriaHint.HintId == pValue) {
                    hintText = criteriaHint.Text;
                    hintId = criteriaHint.HintId;
                    HintTypeIdValue = criteriaHint.HintTypeId;
                    HintFormId = criteriaHint.FormId;
                    HintSectonId = criteriaHint.SectionId;
                    isHintFound = true;
                    break;
                }
            }
        }
    }

    $('#hintEditIconIdIngredients').val(hintId);
    activateModal("#editIconHintModalIngredients");
    var tArea = $("#editIconHintModalIngredients").find(".advanced-textarea");

    var editableCompEdited = $("#editIconHintModalIngredients").find(".editable-component-edited");
    editableCompEdited.show();

    tArea.trumbowyg('html');
    setTimeout(function () { tArea.trumbowyg('html', hintText); }, 100);
    tArea.trumbowyg({
        svgPath: '/Content/trumbowyg/icons.svg',
        urlProtocol: 'http',
        defaultLinkTarget: '_blank',
        btns: [['formatting'], ['bold', 'italic', 'underline'], ['removeformat'], ['link'], ['foreColor']]
        ,
        plugins: {
            fontfamily: {
                fontList: [
                    { name: 'Arial', family: 'Arial, Helvetica, sans-serif' },
                    { name: 'Open Sans', family: '\'Open Sans\', sans-serif' }
                ]
            }
        }
    });

    var trumboBox = editableCompEdited.find(".trumbowyg-box");
    trumboBox.find(".trumbowyg-editor").attr('placeholder', _localizedHintPlaceHolder);

    $("#submitBtnIngredients").one("click",
        function () {
            var sender = tArea;
            var text = removeEmptyHtmlTags($(sender).trumbowyg('html'));
            var specificationHintsShowAsIconToggleButton = $("#specificationHintsShowAsIconToggleButtonIngredients" + hintId);
            var showAsIcon = specificationHintsShowAsIconToggleButton.find("input").prop("checked");

            $('#textIdIngredients').val(JSON.stringify(text));
            $('#hintEditIconIdIngredients').val(hintId);
            $('#paramNameIngredients').val(pName);
            $('#paramValueIngredients').val(pValue);
            $('#colNameIngredients').val('');
            $('#asIconIngredients').val(showAsIcon);
            $('#formIdIngredients').val(HintFormId);
            $('#sectionIdIngredients').val(HintSectonId);

        });

    $("#cancelBtnIngredients").one("click",
        function () {
            RemoveAllNewHints();
        });

    $("#XBtnIngredients").one("click",
        function () {
            RemoveAllNewHints();
        });

    var trumbowygBox = editableCompEdited.find(".trumbowyg-box");
    var trumbowygButtonPane = trumbowygBox.find(".trumbowyg-button-pane");

    var deleteFunctionName = "deleteHintForSpecData";
    var isChecked = "";
    if (HintTypeIdValue == 5 || hintId == 0) {
        isChecked = "checked";
    }

    if (_controllerName != undefined && _controllerName != "" && _controllerName == "INGREDIENTS") {
        deleteFunctionName = "deleteHintForSpecDataIngredients";
    }

    trumbowygButtonPane.find('.vertical-align-center').remove();

    var html = "<div id='specificationHintsShowAsIconToggleButtonIngredients" + hintId + "' class='vertical-align-center block' style='display: normal; margin-left: 20px;'>";
    html += "<div class='toggle-switch' > <label class='switch' ><input type='checkbox' " + isChecked + " autocomplete='off'></input><span class='slider round' style='display: block'></span></label></div >";
    html += "<label class='control-label'>" + _localizedShowAsIcon + "</label>";
    html += "</div>";
    trumbowygButtonPane.append(html);

    html = "<div id='specificationHintsDeleteButton" + hintId + "'  onclick='" + deleteFunctionName+"(\"CriteriaHint-" + hintId + "\")' class='vertical-align-center block' style='display: normal; margin-left: 20px;'>";
    html += "<div class='button'><label class='button' ><button type='button'  autocomplete='off' class='fa fa-trash' ></button></label></div>";
    html += "<label class='control-label'>" + _localizedDeleteHint + "</label>";
    html += "</div>";
    trumbowygButtonPane.append(html);
}

function openForEditHintDefinition(e) {
    var firstParent = $(e.srcElement || e.target).parent();
    var sender = $(e.srcElement || e.target).closest('.editable-component-readonly');
    var hintSectionTypeId = hintSectionTypeId = $(sender).attr('id');
    var splittedSecID = hintSectionTypeId.split('-');
    var hintElementType = splittedSecID[0];
    var hintIdValue = parseInt(splittedSecID[1]);

    $(".editable-component-edited").hide();
    $(".editable-component-readonly").show();
    $(sender).hide();

    var editedComponent = $(sender).siblings(".editable-component-edited");
    editedComponent.show();

    var value = $(sender).html();

    if (!value.replace(/\s/g, '').length) { value = ''; }

    var tArea = editedComponent.find(".advanced-textarea");

    tArea.trumbowyg('html');

    setTimeout(function () { tArea.trumbowyg('html', value); }, 100);
    tArea.trumbowyg({
        svgPath: '/Content/trumbowyg/icons.svg',
        urlProtocol: 'http',
        defaultLinkTarget: '_blank',
        btns: [['formatting'], ['bold', 'italic', 'underline'], ['removeformat'], ['link'], ['foreColor']]
        ,
        plugins: {
            fontfamily: {
                fontList: [
                    { name: 'Arial', family: 'Arial, Helvetica, sans-serif' },
                    { name: 'Open Sans', family: '\'Open Sans\', sans-serif' }
                ]
            }
        }
    });

    var criteriaHintId = "";
    criteriaHintId = parseInt(splittedSecID[2]);

    editedComponent.find(".cancel").one("click",
        function () {
            var readComponent = $(tArea).closest(".editable-component-edited").siblings(".editable-component-readonly");
            readComponent.show();
            $(tArea).closest(".editable-component-edited").hide();
            RemoveAllNewHints();
        });

    var isHintFound = false;
    var HintTypeIdValue = 0;
    var HintElementTypeName = "";

    for (var i in _categoryTopHints) {
        var criteriaHint = _categoryTopHints[i];
        if (criteriaHint.HintId == hintIdValue) {
            HintTypeIdValue = criteriaHint.HintTypeId;
            isHintFound = true;
            HintElementTypeName = criteriaHint.HintElementType;
        }
    }

    if (!isHintFound) {
        for (var i in _categoryBottomHints) {
            var criteriaHint = _categoryBottomHints[i];
            if (criteriaHint.HintId == hintIdValue) {
                HintTypeIdValue = criteriaHint.HintTypeId;
                isHintFound = true;
                HintElementTypeName = criteriaHint.HintElementType;
            }
        }
    }

    if (!isHintFound) {
        for (var i in _columnHeaderHints) {
            var criteriaHint = _columnHeaderHints[i];
            if (criteriaHint.HintId == hintIdValue) {
                HintTypeIdValue = criteriaHint.HintTypeId;
                isHintFound = true;
                HintElementTypeName = criteriaHint.HintElementType;
            }
        }
    }

    if (!isHintFound) {
        for (var i in _criteriaHints) {
            var criteriaHint = _criteriaHints[i];
            if (criteriaHint.HintId == hintIdValue) {
                HintTypeIdValue = criteriaHint.HintTypeId;
                isHintFound = true;
                HintElementTypeName = criteriaHint.HintElementType;
            }
        }
    }

    if (_sectionTopHint != null && _sectionTopHint.HintId == hintIdValue) {
        HintTypeIdValue = _sectionTopHint.HintTypeId;
        isHintFound = true;
        HintElementTypeName = _sectionTopHint.HintElementType;
    }

    if (_sectionBottomHint != null && _sectionBottomHint.HintId == hintIdValue) {
        HintTypeIdValue = _sectionBottomHint.HintTypeId;
        isHintFound = true;
        HintElementTypeName = _sectionBottomHint.HintElementType;
    }

    editedComponent.find(".enter").one("click",
        function () {
            var sender = tArea;
            var specificationHintsShowAsIconToggleButton = $("#specificationHintsShowAsIconToggleButton" + hintIdValue);
            var showAsIcon = specificationHintsShowAsIconToggleButton.find("input").prop("checked");
            var text = removeEmptyHtmlTags($(sender).trumbowyg('html'));

            var readComponent = $(sender).closest(".editable-component-edited").siblings(".editable-component-readonly");

            if (!text) {
                var emptyValue = readComponent
                    .addClass("editable-component-empty")
                    .attr("data-empty-value");
                readComponent
                    .html(emptyValue)
                    .show();
            } else {
                readComponent
                    .removeClass("editable-component-empty")
                    .attr("data-value", JSON.stringify(text))
                    .html(text)
                    .show();
            }

            var th = $(sender).closest("th");
            var columnName = "";
            columnName = th.data("field-name");

            if (columnName == undefined) {
                columnName = th.data("field")
            }

            var jsonModel = JSON.stringify({ hintIdValue: hintIdValue, hintText: text, formId: _formId, sectionId: _sectionId, hintElementType: hintElementType, columnName: columnName, criteriaHintId: criteriaHintId, showAsIcon: showAsIcon, categoryId: _categoryId });
            $.ajax({
                type: "POST",
                url: '/Hints/ChangeHintText',
                dataType: "json",
                data: jsonModel,
                contentType: "application/json",
                success: function (data) {
                    window.location.reload();
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    if (jqXHR.status != 401) {
                        showErrorToastrMessage("Failed.");
                    }
                }
            });

            $(sender).closest(".editable-component-edited").hide();
        });

    var trumboBox = editedComponent.find(".trumbowyg-box");

    trumboBox.css('width', '900px');
    trumboBox.css('margin', '0px');
    trumboBox.find(".trumbowyg-editor").css('min-height', '280px');

    var buttonPane = trumboBox.find(".trumbowyg-button-pane");
    buttonPane.find('.vertical-align-center').remove();

    var isChecked = "";
    if (HintTypeIdValue == 5) {
        isChecked = "checked";
    }

    var isToggleFunction = "";

    if (HintElementTypeName == "ColumnHeader" && HintTypeIdValue == 3 && _controllerName == "SPECIFICATIONDATA") {
        isToggleFunction = " onclick='toggleCheckBox(event);' ";
    }

    var html = "<div id='specificationHintsShowAsIconToggleButton" + hintIdValue + "' class='vertical-align-center block' style='display: normal; margin-left: 20px;'>";
    html += "<div class='toggle-switch' > <label class='switch' ><input type='checkbox' " + isChecked + "   autocomplete='off'></input><span " + isToggleFunction + " class='slider round'  style='display: block'></span></label></div >";
    html += "<label class='control-label'>" + _localizedShowAsIcon + "</label>";
    html += "</div>";
    buttonPane.append(html);

    html = "<div id='specificationHintsDeleteButton" + hintIdValue + "'  onclick='deleteHint(\"" + hintSectionTypeId + "\")' class='vertical-align-center block' style='display: normal; margin-left: 20px;'>";
    html += "<div class='button'><label class='button' ><button type='button'  autocomplete='off' class='fa fa-trash' ></button></label></div>";
    html += "<label class='control-label'>" + _localizedDeleteHint + "</label>";
    html += "</div>";
    buttonPane.append(html);
}

function openForEditIconHintIngredientsDefinitionColumn(e) {
    var sender = $(e.srcElement || e.target).parent();

    var pname = "";
    var pvalue = 0;

    var firstAttr = $(sender).attr('id');
    if (firstAttr != undefined) {
        var firstAttrSplitted = firstAttr.split('-');

        pName = firstAttrSplitted[0];
        pValue = parseInt(firstAttrSplitted[1]);

    } else {


        var element = sender.find(".editable-component-readonly");
        var hintSectionTypeId = $(element).attr('id');
        var splittedSecID = hintSectionTypeId.split('-');
        pName = splittedSecID[0];
        pValue = parseInt(splittedSecID[1]);
    }
    var hintText = "";
    var hintId = 0;

    var HintTypeIdValue = 0;
    var columnName = "";
    var HintFormId = 0;
    var HintSectonId = 0;

    for (var i in _columnHeaderHints) {
        var criteriaHint = _columnHeaderHints[i];
        if (criteriaHint.HintElementType == "ColumnHeader" && criteriaHint.HintId == pValue) {
            hintText = criteriaHint.Text;
            hintId = criteriaHint.HintId;
            HintTypeIdValue = criteriaHint.HintTypeId;
            columnName = criteriaHint.ColumnName;
            HintFormId = criteriaHint.FormId;
            HintSectonId = criteriaHint.SectionId;
            break;
        }
    }

    $('#hintEditIconIdIngredients').val(hintId);
    activateModal("#editIconHintModalIngredients");
    var tArea = $("#editIconHintModalIngredients").find(".advanced-textarea");

    var editableCompEdited = $("#editIconHintModalIngredients").find(".editable-component-edited");
    editableCompEdited.show();

    tArea.trumbowyg('html');
    setTimeout(function () { tArea.trumbowyg('html', hintText); }, 100);
    tArea.trumbowyg({
        svgPath: '/Content/trumbowyg/icons.svg',
        urlProtocol: 'http',
        defaultLinkTarget: '_blank',
        btns: [['formatting'], ['bold', 'italic', 'underline'], ['removeformat'], ['link'], ['foreColor']]
        ,
        plugins: {
            fontfamily: {
                fontList: [
                    { name: 'Arial', family: 'Arial, Helvetica, sans-serif' },
                    { name: 'Open Sans', family: '\'Open Sans\', sans-serif' }
                ]
            }
        }
    });

    var trumboBox = editableCompEdited.find(".trumbowyg-box");
    trumboBox.find(".trumbowyg-editor").attr('placeholder', _localizedHintPlaceHolder);

    $("#submitBtnIngredients").one("click",
        function () {
            var sender = tArea;
            var text = removeEmptyHtmlTags($(sender).trumbowyg('html'));
            var specificationHintsShowAsIconToggleButton = $("#specificationHintsShowAsIconToggleButtonIngredients" + hintId);
            var showAsIcon = specificationHintsShowAsIconToggleButton.find("input").prop("checked");
            $('#textIdIngredients').val(JSON.stringify(text));
            $('#hintEditIconIdIngredients').val(hintId);
            $('#paramNameIngredients').val(pName);
            $('#paramValueIngredients').val(pValue);
            $('#colNameIngredients').val(columnName);
            $('#asIconIngredients').val(showAsIcon);
            $('#formIdIngredients').val(HintFormId);
            $('#sectionIdIngredients').val(HintSectonId);
        });

    $("#cancelBtnIngredients").one("click",
        function () {

            RemoveAllNewHints();
        });

    $("#XBtnIngredients").one("click",
        function () {
            RemoveAllNewHints();
        });

    var trumbowygBox = editableCompEdited.find(".trumbowyg-box");
    var trumbowygButtonPane = trumbowygBox.find(".trumbowyg-button-pane");

    var isChecked = "";
    if (HintTypeIdValue == 5 || hintId == 0) {
        isChecked = "checked";
    }

    trumbowygButtonPane.find('.vertical-align-center').remove();

    var html = "<div id='specificationHintsShowAsIconToggleButtonIngredients" + hintId + "' class='vertical-align-center block' style='display: normal; margin-left: 20px;'>";
    html += "<div class='toggle-switch' > <label class='switch' ><input type='checkbox' " + isChecked + " autocomplete='off'></input><span class='slider round' style='display: block'></span></label></div >";
    html += "<label class='control-label'>" + _localizedShowAsIcon + "</label>";
    html += "</div>";
    trumbowygButtonPane.append(html);

    html = "<div id='specificationHintsDeleteButton" + hintId + "'  onclick='deleteHintForSpecDataIngredients(\"CriteriaHint-" + hintId + "\")' class='vertical-align-center block' style='display: normal; margin-left: 20px;'>";
    html += "<div class='button'><label class='button' ><button type='button'  autocomplete='off' class='fa fa-trash' ></button></label></div>";
    html += "<label class='control-label'>" + _localizedDeleteHint + "</label>";
    html += "</div>";
    trumbowygButtonPane.append(html);
}

function openForEditIconHintIngredientsDefinition(e) {
    var sender = $(e.srcElement || e.target).parent();
    var hintSectionTypeId = $(sender).data('hint-id');
    var splittedSecID = hintSectionTypeId.split('-');
    var pName = splittedSecID[0];
    var pValue = parseInt(splittedSecID[1]);
    var hintText = ""; 
    var hintId = 0;

    var HintTypeIdValue = 0;
    var HintFormId = 0;
    var HintSectonId = 0;

    for (var i in _columnHeaderHints) {
        var criteriaHint = _columnHeaderHints[i];
        if (criteriaHint.HintElementType == "ColumnHeader" && criteriaHint.HintId == pValue) {
            hintText = criteriaHint.Text;
            hintId = criteriaHint.HintId;
            HintTypeIdValue = criteriaHint.HintTypeId;
            HintFormId = criteriaHint.FormId;
            HintSectonId = criteriaHint.SectionId;
            break;
        }
    }

    $('#hintEditIconIdIngredients').val(hintId);
    activateModal("#editIconHintModalIngredients");
    var tArea = $("#editIconHintModalIngredients").find(".advanced-textarea");

    var editableCompEdited = $("#editIconHintModalIngredients").find(".editable-component-edited");
    editableCompEdited.show();

    tArea.trumbowyg('html');
    setTimeout(function () { tArea.trumbowyg('html', hintText); }, 100);
    tArea.trumbowyg({
        svgPath: '/Content/trumbowyg/icons.svg',
        urlProtocol: 'http',
        defaultLinkTarget: '_blank',
        btns: [['formatting'], ['bold', 'italic', 'underline'], ['removeformat'], ['link'], ['foreColor']]
        ,
        plugins: {
            fontfamily: {
                fontList: [
                    { name: 'Arial', family: 'Arial, Helvetica, sans-serif' },
                    { name: 'Open Sans', family: '\'Open Sans\', sans-serif' }
                ]
            }
        }
    });

    var trumboBox = editableCompEdited.find(".trumbowyg-box");
    trumboBox.find(".trumbowyg-editor").attr('placeholder', _localizedHintPlaceHolder);

    $("#submitBtnIngredients").one("click",
        function () {
            var sender = tArea;
            var text = removeEmptyHtmlTags($(sender).trumbowyg('html'));
            var specificationHintsShowAsIconToggleButton = $("#specificationHintsShowAsIconToggleButtonIngredients" + hintId);
            var showAsIcon = specificationHintsShowAsIconToggleButton.find("input").prop("checked");

            $('#textIdIngredients').val(JSON.stringify(text));
            $('#hintEditIconIdIngredients').val(hintId);
            $('#paramNameIngredients').val(pName);
            $('#paramValueIngredients').val(pValue);
            $('#colNameIngredients').val('');
            $('#asIconIngredients').val(showAsIcon);
            $('#formIdIngredients').val(HintFormId);
            $('#sectionIdIngredients').val(HintSectonId);

        });

    $("#cancelBtnIngredients").one("click",
        function () {
            RemoveAllNewHints();
        });

    $("#XBtnIngredients").one("click",
        function () {
            RemoveAllNewHints();
        });

    var trumbowygBox = editableCompEdited.find(".trumbowyg-box");
    var trumbowygButtonPane = trumbowygBox.find(".trumbowyg-button-pane");

    var isChecked = "";
    var deleteFunctionName = "deleteHintForSpecData";

    if (HintTypeIdValue == 5 || hintId == 0) {
        isChecked = "checked";
    }

    if (_controllerName != undefined && _controllerName != "" && _controllerName == "INGREDIENTS") {
        deleteFunctionName = "deleteHintForSpecDataIngredients";
    }

    trumbowygButtonPane.find('.vertical-align-center').remove();

    var html = "<div id='specificationHintsShowAsIconToggleButtonIngredients" + hintId + "' class='vertical-align-center block' style='display: normal; margin-left: 20px;'>";
    html += "<div class='toggle-switch' > <label class='switch' ><input type='checkbox' " + isChecked + " autocomplete='off'></input><span class='slider round' style='display: block'></span></label></div >";
    html += "<label class='control-label'>" + _localizedShowAsIcon + "</label>";
    html += "</div>";
    trumbowygButtonPane.append(html);

    html = "<div id='specificationHintsDeleteButton" + hintId + "'  onclick='" + deleteFunctionName+"(\"CriteriaHint-" + hintId + "\")' class='vertical-align-center block' style='display: normal; margin-left: 20px;'>";
    html += "<div class='button'><label class='button' ><button type='button'  autocomplete='off' class='fa fa-trash' ></button></label></div>";
    html += "<label class='control-label'>" + _localizedDeleteHint + "</label>";
    html += "</div>";
    trumbowygButtonPane.append(html);
}

function toggleCheckBox(e) {
    var sender = $(e.srcElement || e.target).siblings('input');

    if ($(sender).is(":checked")) {
        $(sender).prop('checked', false);
    } else {
        $(sender).prop('checked', true);
    }
}

function AddSectionTopHint() {
    var url = _addHintUrl + "&hintElementType=" + "SectionTopHintLb" + "&hintColumnaName=" + "" + "&hintCriteriaId=" + "" + "&hintControlId=" + "" + "&parameterName=" + "" + "&parameterValue=" + "";
    $.get(url, newHint);
    function newHint(data) {
        _sectionTopHint = data;
        viewSpecificationHints(true);
        var createdHint = OpenNewlyCreatedHint("sectionTopHint");
        if (createdHint != null) {
            $("#sectionTopHint-" + createdHint.HintId).click();
        }
    }
}

function AddSectionBottomHint() {
    var url = _addHintUrl + "&hintElementType=" + "SectionBottomHintLb" + "&hintColumnaName=" + "" + "&hintCriteriaId=" + "" + "&hintControlId=" + "" + "&parameterName=" + "" + "&parameterValue=" + "";
    $.get(url, newHint);
    function newHint(data) {
        _sectionBottomHint = data;
        viewSpecificationHints(true);
        var createdHint = OpenNewlyCreatedHint("sectionBottomHint");
        if (createdHint != null) {
            $("#sectionBottomHint-" + createdHint.HintId).click();
        }
    }
}

function AddCategoryTopHint(categoryId) {
    var url = _addHintUrl + "&hintElementType=" + "CategoryTopHintLb" + "&hintColumnaName=" + "" + "&hintCriteriaId=" + "" + "&hintControlId=" + "" + "&parameterName=" + "" + "&parameterValue=" + categoryId;
    $.get(url, newHint);
    function newHint(data) {
        _categoryTopHints.push(data);
        viewSpecificationHints(true);
        var createdHint = OpenNewlyCreatedHint("CategoryTopHint");
        if (createdHint != null) {
            $("#CategoryTopHint-" + createdHint.HintId + "-" + createdHint.ParamValue).click();
        }
    }
}

function AddCategoryBottomHint(categoryId) {
    var url = _addHintUrl + "&hintElementType=" + "CategoryBottomHintLb" + "&hintColumnaName=" + "" + "&hintCriteriaId=" + "" + "&hintControlId=" + "" + "&parameterName=" + "" + "&parameterValue=" + categoryId;
    $.get(url, newHint);
    function newHint(data) {
        _categoryBottomHints.push(data);
        viewSpecificationHints(true);
        var createdHint = OpenNewlyCreatedHint("CategoryBottomHint");
        if (createdHint != null) {
            $("#CategoryBottomHint-" + createdHint.HintId + "-" + createdHint.ParamValue).click();
        }
    }
}

function AddColumnHint(colName) {
    var url = _addHintUrl + "&hintElementType=" + "ColumnHeader" + "&hintColumnaName=" + colName + "&hintCriteriaId=" + "" + "&hintControlId=" + "" + "&parameterName=" + "" + "&parameterValue=" + "";
    $.get(url, newHint);
    function newHint(data) {
        _columnHeaderHints.push(data);
        viewSpecificationHints(true);
        var createdHint = OpenNewlyCreatedHint("ColumnHeader");
        if (createdHint != null) {
            $("#" + createdHint.HintElementType + "-" + createdHint.HintId).click();
        }
    }
}

function AddCriteriaHint(criteriaId) {
    var url = _addHintUrl + "&hintElementType=" + "CriteriaHint" + "&hintColumnaName=" + "" + "&hintCriteriaId=" + criteriaId + "&hintControlId=" + "" + "&parameterName=" + "CriteriaID" + "&parameterValue=" + "";
    $.get(url, newHint);
    function newHint(data) {
        _criteriaHints.push(data);
        viewSpecificationHints(true);
        var createdHint = OpenNewlyCreatedHint("CriteriaHint");
        if (createdHint != null) {
            var clientId = "";
            if (createdHint.HintTypeId == 5) {
                clientId = "[data-hint-id='" + createdHint.ParamName + "_" + createdHint.ParamValue + "_" + createdHint.ColumnName + "_I']";

            } else {
                clientId = "[data-hint-id='" + createdHint.ParamName + "_" + createdHint.ParamValue + "_" + createdHint.ColumnName + "_T']";
            }

            var element = $(clientId);
            element.click();
        }
    }
}

function RemoveAllNewHints() {
    if (_sectionTopHint != null && _sectionTopHint.HintId == 0) {
        _sectionTopHint = null;
    }

    if (_sectionBottomHint != null && _sectionBottomHint.HintId == 0) {
        _sectionBottomHint = null;
    }

    if (_categoryTopHints != null) {
        for (var i in _categoryTopHints) {
            var hint = _categoryTopHints[i];
            if (hint.HintId == 0) {
                delete _categoryTopHints[i];
            }
        }
    }

    if (_categoryBottomHints != null) {
        for (var i in _categoryBottomHints) {
            var hint = _categoryBottomHints[i];
            if (hint.HintId == 0) {
                delete _categoryBottomHints[i];
            }
        }
    }

    if (_columnHeaderHints != null) {
        for (var i in _columnHeaderHints) {
            var hint = _columnHeaderHints[i];
            if (hint.HintId == 0) {
                delete _columnHeaderHints[i];
            }
        }
    }

    if (_criteriaHints != null) {
        for (var i in _criteriaHints) {
            var hint = _criteriaHints[i];
            if (hint.HintId == 0) {
                delete _criteriaHints[i];
            }
        }
    }

    viewSpecificationHints(true);

    $("#ColumnHeader-0").each(function () {
        $(this).remove();
    });
}

function OpenNewlyCreatedHint(hintElementType) {

    if (hintElementType == 'sectionTopHint' && _sectionTopHint != null && _sectionTopHint.HintId == 0) {
        return _sectionTopHint;
    }

    if (hintElementType == 'sectionBottomHint' && _sectionBottomHint != null && _sectionBottomHint.HintId == 0) {
        return _sectionBottomHint;
    }

    if (hintElementType == 'CategoryTopHint' && _categoryTopHints != null) {
        var foundHint = GetCategoryTopHintById(0);
        if (foundHint != null) { return foundHint; }
    }

    if (hintElementType == 'CategoryBottomHint' && _categoryBottomHints != null) {
        var foundHint = GetCategoryBottomHintById(0);
        if (foundHint != null) { return foundHint; }
    }

    if (hintElementType == 'ColumnHeader' && _columnHeaderHints != null) {
        var foundHint = GetColumnHeaderHintById(0);
        if (foundHint != null) { return foundHint; }
    }

    if (hintElementType == 'CriteriaHint' && _criteriaHints != null) {
        var foundHint = GetCriteriaHintById(0);
        if (foundHint != null) { return foundHint; }
    }
}

function GetColumnHeaderHintById(hintId) {
    if (_columnHeaderHints == null) { return null; }

    for (var i in _columnHeaderHints) {
        var hint = _columnHeaderHints[i];
        if (hint.HintId == hintId) {
            return hint;
        }
    }
}

function GetCategoryTopHintById(hintId) {
    if (_categoryTopHints == null) { return null; }

    for (var i in _categoryTopHints) {
        var hint = _categoryTopHints[i];
        if (hint.HintId == hintId) {
            return hint;
        }
    }
}

function GetCategoryBottomHintById(hintId) {
    if (_categoryBottomHints == null) { return null; }

    for (var i in _categoryBottomHints) {
        var hint = _categoryBottomHints[i];
        if (hint.HintId == hintId) {
            return hint;
        }
    }
}

function GetCriteriaHintById(hintId) {
    if (_criteriaHints == null) { return null; }

    for (var i in _criteriaHints) {
        var hint = _criteriaHints[i];
        if (hint.HintId == hintId) {
            return hint;
        }
    }
}

function AddEditHintModule(options) {
    _controllerName = options.controllerName;
    if (options.isEdit == 'true') {
        this.options = options;
        this.load();
    }
}

function InsertSection(row) {
    var nextIndex = $(row).index() + 2;
    $("#insertNewSectionModal #position").val(nextIndex);
    activateModal("#insertNewSectionModal");
}

AddEditHintModule.prototype = {
    constructor: AddEditHintModule,
    options: {},
    IsPdmCompany: false,
    load: function () {
        var menu = new BootstrapMenu('.section.active', {
            fetchElementData: function ($rowElem) {
                return $rowElem;
            },
            actions: [
                { //Rename section
                    name: this.options.translations.rename,
                    iconClass: 'fa-pencil',
                    onClick: function (row) {
                        $(row).find('.sections_edit').click();
                    },
                    isShown: function (row) {
                        return true;
                    },
                    isEnabled: function (row) {
                        return true;
                    }.bind(this)
                },
                { // insert section
                    name: this.options.translations.insertSection,
                    iconClass: 'fa-plus',
                    isShown: function (row) {
                        return true;
                    },
                    onClick: function (row) {
                        InsertSection(row);
                    },
                    isEnabled: function (row) {
                        return true;
                    }.bind(this)
                },
                { // delete section
                    name: this.options.translations.deleteSection,
                    iconClass: 'fa-trash',
                    isShown: function (row) {
                        return true;
                    },
                    onClick: function (row) {
                       this.deleteSectionModal();
                    }.bind(this),
                    isEnabled: function (row) {
                        return true;
                    }.bind(this)
                },
                { //add SectionTopHint
                    name: this.options.translations.addTopHint,
                    iconClass: 'fa-info-circle',
                    isShown: function (row) {
                        if (_sectionTopHint != null && $('#sectionTopHint-' + _sectionTopHint.HintId)) { return false; } else { return true; }
                    },
                    onClick: function (row) {
                        AddSectionTopHint();
                    },
                    isEnabled: function (row) {
                        return true;
                    }.bind(this)
                },
                { //edit SectionTopHint
                    name: this.options.translations.renameTopHint,
                    iconClass: 'fa-info-circle',
                    isShown: function (row) {
                        if (_sectionTopHint != null && $('#sectionTopHint-' + _sectionTopHint.HintId)) { return true; } else { return false; }
                    },
                    onClick: function (row) {
                        $('#sectionTopHint-' + _sectionTopHint.HintId).click();
                        var secTopElem = $('[data-hint-id="sectionTopHint-' + _sectionTopHint.HintId + '"]');
                        if (secTopElem != undefined) {
                            secTopElem.click();
                        }
                    },
                    isEnabled: function (row) {
                        return true;
                    }.bind(this)
                },
                { //add SectionBottomHint
                    name: this.options.translations.addBottomHint,
                    iconClass: 'fa-info-circle',
                    isShown: function (row) {
                        if (_sectionBottomHint != null && $('#sectionBottomHint-' + _sectionBottomHint.HintId)) { return false; } else { return true; }
                    },
                    onClick: function (row) {
                        AddSectionBottomHint();
                    },
                    isEnabled: function (row) {
                        return true;
                    }.bind(this)
                },
                { //edit SectionBottomHint
                    name: this.options.translations.renameBottomHint,
                    iconClass: 'fa-info-circle',
                    isShown: function (row) {
                        if (_sectionBottomHint != null && $('#sectionBottomHint-' + _sectionBottomHint.HintId)) { return true; } else { return false; }
                    },
                    onClick: function (row) {
                        $('#sectionBottomHint-' + _sectionBottomHint.HintId).click();
                        var secBotElem = $('[data-hint-id="sectionBottomHint-' + _sectionBottomHint.HintId + '"]');
                        if (secBotElem != undefined) {
                            secBotElem.click();
                        }
                    },
                    isEnabled: function (row) {
                        return true;
                    }.bind(this)
                }
            ]
        });
    },
    deleteSectionModal: function () {
        $.ajax({
            url: this.options.urls.deleteSectionModal,
            type: "GET",
            dataType: 'html',
            contentType: "application/json",
            data: { id: _sectionId },
            success: function (data) {
                $('#modalWindow').html(data);
                activateModal("#deleteSectionModal");
            }
        });
    }
}

function AddEditIngredientCategoryModule(options) {
    _controllerName = options.controllerName;
    if (options.isEdit == 'true') {
        this.options = options;
        this.load();
    }
}

AddEditIngredientCategoryModule.prototype = {
    constructor: AddEditIngredientCategoryModule,
    options: {},
    IsPdmCompany: false,
    load: function () {
        var menu = new BootstrapMenu('.ingredient-category.special-active', {
            fetchElementData: function ($rowElem) {
                return $rowElem;
            },
            actions: [
                { //Rename section
                    name: this.options.translations.rename,
                    iconClass: 'fa-pencil',
                    onClick: function (row) {
                        $(row).find('.sections_edit').click();
                    },
                    isShown: function (row) {
                        var secEdit = $(row).find('.sections_edit');
                        if (secEdit.length > 0 && secEdit.data("enabled") == true) {
                            return true;
                        } else { return false;}
                    },
                    isEnabled: function (row) {
                        return true;
                    }.bind(this)
                } ,
                 {
                     name: this.options.translations.addTopHint,
                    iconClass: 'fa-info-circle',
                    classNames: 'category-menu-item',
                    onClick: function (row) {
                        var categoryId = $(row).data("categoryId");
                        AddCategoryTopHint(categoryId);
                    }.bind(this),
                    isShown: function (row) {
                        var pValue = row.data("category-id");
                        for (var i in _categoryTopHints) {
                            var criteriaHint = _categoryTopHints[i];
                            if ((criteriaHint.HintElementType == "CategoryTopHint") && criteriaHint.ParamValue == pValue) {
                                return false;
                                break;
                            }
                        }
                        return true;
                    },
                    isEnabled: function (row) {
                        return true;
                    }.bind(this)
                },
                 {
                     name: this.options.translations.renameTopHint,
                    iconClass: 'fa-info-circle',
                    classNames: 'category-menu-item',
                    onClick: function (row) {
                        var categoryId = $(row).data("categoryId");

                        for (var i in _categoryTopHints) {
                            var criteriaHint = _categoryTopHints[i];
                            if ((criteriaHint.HintElementType == "CategoryTopHint") && criteriaHint.ParamValue == categoryId) {
                                var hintEditObject = $("#CategoryTopHint-" + criteriaHint.HintId + "-" + categoryId);
                                if (hintEditObject.length > 0) {
                                    hintEditObject.click();
                                }

                                var secBotElem = $('[id="CategoryTopHintText"]');
                                if (secBotElem != undefined) {
                                    secBotElem.click();
                                }
                            }
                        }
                    }.bind(this),
                    isShown: function (row) {
                        var pValue = row.data("category-id");
                        for (var i in _categoryTopHints) {
                            var criteriaHint = _categoryTopHints[i];
                            if ((criteriaHint.HintElementType == "CategoryTopHint") && criteriaHint.ParamValue == pValue) {
                                return true;
                                break;
                            }
                        }
                        return false;
                    },
                    isEnabled: function (row) {
                        return true;
                    }.bind(this)
                }
                ,

                 {
                    name: this.options.translations.addBottomHint,
                    iconClass: 'fa-info-circle',
                    classNames: 'category-menu-item',
                    onClick: function (row) {
                        var categoryId = $(row).data("categoryId");
                        AddCategoryBottomHint(categoryId);
                    }.bind(this),
                    isShown: function (row) {
                        var pValue = row.data("category-id");
                        for (var i in _categoryBottomHints) {
                            var criteriaHint = _categoryBottomHints[i];
                            if ((criteriaHint.HintElementType == "CategoryBottomHint") && criteriaHint.ParamValue == pValue) {
                                return false;
                                break;
                            }
                        }
                        return true;
                    },
                    isEnabled: function (row) {
                        return true;
                    }.bind(this)
                },

                 {
                    name: this.options.translations.renameBottomHint,
                    iconClass: 'fa-info-circle',
                    classNames: 'category-menu-item',
                    onClick: function (row) {

                        var categoryId = $(row).data("categoryId");
                        for (var i in _categoryBottomHints) {
                            var criteriaHint = _categoryBottomHints[i];
                            if ((criteriaHint.HintElementType == "CategoryBottomHint") && criteriaHint.ParamValue == categoryId) {
                                var hintEditObject = $("#CategoryBottomHint-" + criteriaHint.HintId + "-" + categoryId);
                                if (hintEditObject.length > 0) {
                                    hintEditObject.click();
                                }

                                var secBotElem = $('[data-hint-id="CategoryBottomHint-' + criteriaHint.HintId + '"]');
                                if (secBotElem != undefined) {
                                    secBotElem.click();
                                }
                            }
                        }
                    }.bind(this),
                    isShown: function (row) {
                        var pValue = row.data("category-id");
                        for (var i in _categoryBottomHints) {
                            var criteriaHint = _categoryBottomHints[i];
                            if ((criteriaHint.HintElementType == "CategoryBottomHint") && criteriaHint.ParamValue == pValue) {
                                return true;
                            }
                        }
                        return false;
                    },
                    isEnabled: function (row) {
                        return true;
                    }.bind(this)
                }
            ]
        });
    }
}